export default {
  /**
   * 更新产品ID
   * @param {*} state
   * @param {*} value
   */
  updateProductId (state, value) {
    state.order.productId = value
  },

  /**
   * 更新用户微信ID
   * @param {*} state
   * @param {*} value
   */
  updateUserId (state, value) {
    state.order.userId = value
  },

  /**
   * 更新是否确认回访信息
   * @param {*} state
   * @param {*} value
   */
  updateOrderConfirmFeedback (state, value) {
    state.order.confirmFeedback = value
  },

  /**
   * 更新用户留言
   * @param {*} state
   * @param {*} value
   */
  updateHolderMessage (state, value) {
    state.holder.message = value
  },

  /**
   * 更新银行
   * @param {*} state
   * @param {*} value
   */
  updateHolderBankName (state, value) {
    state.holder.bankName = value
  },

  /**
   * 更新银行卡号
   * @param {*} state
   * @param {*} value
   */
  updateHolderBankCardNumber (state, value) {
    state.holder.bankCardNumber = value
  },

  /**
   * 更新投保人姓名
   * @param {*} state
   * @param {*} value
   */
  updateHolderName (state, value) {
    state.holder.name = value
  },

  /**
   * 更新投保人身份证号
   * @param {*} state
   * @param {*} value
   */
  updateHolderIDNumber (state, value) {
    state.holder.IDNumber = value
  },

  /**
   * 更新投保人手机号
   * @param {*} state
   * @param {*} value
   */
  updateHolderPhoneNumber (state, value) {
    state.holder.phoneNumber = value
  },

  /**
   * 更新投保人详细地址
   * @param {*} state
   * @param {*} value
   */
  updateHolderAddress (state, value) {
    state.holder.address = value
  },

  /**
   * 更新投保人所在地区
   * @param {*} state
   * @param {*} value
   */
  updateHolderArea (state, value) {
    state.holder.area = value
  },

  /**
   * 更新投保人电子邮箱
   * @param {*} state
   * @param {*} value
   */
  updateHolderEmail (state, value) {
    state.holder.email = value
  },

  /**
   * 更新验证码
   * @param {*} state
   * @param {*} value
   */
  updateHolderCAPTCHA (state, value) {
    state.holder.CAPTCHA = value
  },

  /**
   * 更新真实验证码
   * @param {*} state
   * @param {*} value
   */
  updateHolderRealCAPTCHA (state, value) {
    state.holder.realCAPTCHA = value
  },

  /**
   * 更新被保人姓名
   * @param {*} state
   * @param {*} value
   */
  updateInsuredName (state, value) {
    state.insured.name = value
  },

  /**
   * 更新被保人身份证号
   * @param {*} state
   * @param {*} value
   */
  updateInsuredIDNumber (state, value) {
    state.insured.IDNumber = value
  },

  /**
   * 更新订单的给谁投保
   * @param {*} state
   * @param {*} value
   */
  updateOrderInsuredValue (state, value) {
    state.order.insuredValue = value
  },

  /**
   * 更新订单的保障额度
   * @param {*} state
   * @param {*} value
   */
  updateOrderInsuranceAmount (state, value) {
    state.order.insuranceAmount = value
  },

  /**
   * 更新订单的交费期间
   * @param {*} state
   * @param {*} value
   */
  updateOrderPaymentPeriod (state, value) {
    state.order.paymentPeriod = value
  },

  /**
   * 更新被保人出生日期
   * @param {*} state
   * @param {*} value
   */
  updateInsuredBirthday (state, value) {
    state.insured.birthday = value
  },

  /**
   * 更新保单的保险期间
   * @param {*} state
   * @param {*} value
   */
  updateOrderInsurancePeriod (state, value) {
    state.order.insurancePeriod = value
  },

  /**
   * 更新保单的交费方式
   * @param {*} state
   * @param {*} value
   */
  updateOrderPaymentMethod (state, value) {
    state.order.paymentMethod = value
  },

  /**
   * 更新被保人性别
   * @param {*} state
   * @param {*} value
   */
  updateInsuredSex (state, value) {
    state.insured.sex = value
  },

  /**
   * 更新测算保费
   * @param {*} state
   * @param {*} value
   */
  updateMeasurePayment (state, value) {
    state.order.measurePayment = value
  },

  /**
   * 更新正式保费
   * @param {*} state
   * @param {*} value
   */
  updatePaymentByIDNumber (state, value) {
    state.order.paymentByIDNumber = value
  },

  /**
   * 更新身份证有效期
   * @param {*} state
   * @param {*} value
   */
  updateIDNumberExpire (state, value) {
    state.insured.IDNumberExpire = value
  },

  /**
   * 更新订单号
   * @param {*} state
   * @param {*} value
   */
  updateOrderNumber (state, value) {
    state.order.number = value
  },

  /**
   * 更新用户的unionOrderCode
   * @param {*} state
   * @param {*} value
   */
  updateOrderUnionOrderCode (state, value) {
    state.order.unionOrderCode = value
  },

  /**
   * 更新用户的openId
   * @param {*} state
   * @param {*} value
   */
  updateOrderOpenId (state, value) {
    state.order.openId = value
  },

  /**
   * 更新产品名称
   * @param {*} state
   * @param {*} value
   */
  updateOrderName (state, value) {
    state.order.name = value
  },

  /**
   * 更新公司名称
   * @param {*} state
   * @param {*} value
   */
  updateOrderCompany (state, value) {
    state.order.company = value
  },

  /**
   * 更新剩余时间
   * @param {*} state
   * @param {*} value
   */
  updateOrderCountdownTimer (state, value) {
    state.order.countdownTimer = value
  },

  /**
   * 更新测试条件是否充足
   * @param {*} state
   * @param {*} value
   */
  updateMeasureReady (state, value) {
    state.order.measureReady = value
  },

  /**
   * 保费显示暂无
   * @param {*} state
   * @param {*} value
   */
  updatePaymentShowNull (state, value) {
    state.order.paymentShowNull = value
  },

  updateOccupationCode (state, value) {
    state.insured.occupationCode = value
  },

  updateOccupationName (state, value) {
    state.insured.occupationName = value
  },

  updatePositivePicValue (state, value) {
    state.holder.positivePicValue = value
  },

  updateNegativePicValue (state, value) {
    state.holder.negativePicValue = value
  },

  updatePositivePicSrc (state, value) {
    state.holder.positivePicSrc = value
  },

  updateNegativePicSrc (state, value) {
    state.holder.negativePicSrc = value
  },

  updateH5Configuration (state, value) {
    state.h5.configuration = value
  },

  /**
   * 更新选择状态
   * @param {*} state
   * @param {*} index
   * @param {*} status
   */
  updateTicketSelectedStatus (state, index) {
    if (state.activity.tickets[index].selected) {
      state.activity.tickets[index].selected = false
    } else {
      const type = state.activity.tickets[index].type
      state.activity.tickets.forEach((ele) => {
        if (ele.type === type) {
          ele.selected = false
        }
      })
      state.activity.tickets[index].selected = true
    }
  },

  updateActivityTickets (state, value) {
    value.forEach((ele) => {
      const t = {}
      t.selected = false
      for (let i in ele) {
        t[i] = ele[i]
      }
      state.activity.tickets.push(t)
    })
  },

  updateAmountBySelectedTickets (state, value) {
    state.activity.amountBySelectedTickets = value
  },

  // 银行列表存储
  UPDATE_RAWBANKSFROMSERVER (state, value) {
    console.log(value)
    state.banksFromServer = value
  },

  UPDATE_BANKSFROMSERVER (state, value) {
    console.log(value)
    state.wechatpaybanklist = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js